/*
 * tab switch
 */
import Vue from 'vue';


const tab1 = new Vue({
  el: '.js-tab-1',
  data: {
    current: 0,
  },
  methods: {
    show: function (name) {
      this.current = name;
    },
    isCurrent: function (name) {
      return this.current == name;
    },
  },
});


const tab2 = new Vue({
  el: '.js-tab-2',
  data: {
    current: 0,
  },
  methods: {
    show: function (name) {
      this.current = name;
    },
    isCurrent: function (name) {
      return this.current == name;
    },
  },
});


const tab3 = new Vue({
  el: '.js-tab-3',
  data: {
    current: 0,
  },
  methods: {
    show: function (name) {
      this.current = name;
    },
    isCurrent: function (name) {
      return this.current == name;
    },
  },
});


const tab4 = new Vue({
  el: '.js-tab-4',
  data: {
    current: 0,
  },
  methods: {
    show: function (name) {
      this.current = name;
    },
    isCurrent: function (name) {
      return this.current == name;
    },
  },
});


const tab5 = new Vue({
  el: '.js-tab-5',
  data: {
    current: 0,
  },
  methods: {
    show: function (name) {
      this.current = name;
    },
    isCurrent: function (name) {
      return this.current == name;
    },
  },
});
